module.exports = __webpack_public_path__ + "img/all.47a4f203.png";